import * as Yup from 'yup';

export const validationSchema = () => {
    return Yup.object().shape({
        email: Yup.string().required('Email is required')
            .email('Invalid email format')
            .min(5, 'Email must be at least 2 characters')
            .max(100, 'Email must not exceed 100 characters')
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                'Invalid email format'
            ),
        phone_number: Yup.string().required("Mobile Number Is Required").matches(/^[6-9]\d{9}$/, "Invalid Mobile Number"),
        business_type: Yup.string().notRequired(),
        gst_number: Yup.string().when("business_type", {
            is: 'gst',
            then: (schema) => schema.required("GST Number Is Required").matches(/^([0-9]{2})([A-Z]{5}[0-9]{4}[A-Z]{1})([1-9A-Z]{1})(Z)([A-Z0-9]{1})$/, 'Invalid GST Number'),
            otherwise: (schema) => schema.notRequired(),
        }),
        otp: Yup.string()
            .required("OTP is required")
            .matches(/^\d+$/, "Invalid OTP")
            .matches(/^\d{4}$/, "OTP must be 4 digits"),
})
}